import * as React from 'react';

import {
  IDeveloperCell,
  IGalleryCell,
  IInfrastructureCell,
  ILinkCell,
  INewbuildingSummaryCell,
  IPriceCell,
  IPromotionCell,
  IRoomStatsCell,
  ITextCell,
  ITextListCell,
  ITransportDistanceCell,
  ITransportPointCell,
  ITransportPointExtendedCell,
  TNewbuildingsCompareCell,
  TNewbuildingsCompareRow,
} from '../../../../types/newbuildingsCompare';
import {
  DeveloperCell,
  InfrastructureCell,
  LinkCell,
  NewbuildingSummaryCell,
  NewbuildingSummaryCellFloating,
  PromotionCell,
  RoomStatsCell,
  TextCell,
  TextListCell,
  TransportDistanceCell,
  TransportPointCell,
  TransportPointExtendedCell,
} from './cells';
import { PriceCell } from './cells/PriceCell';
import { GalleryCell } from './cells/GalleryCell/GalleryCell';

export interface ICellProps {
  type: TNewbuildingsCompareRow['type'];
  cell: TNewbuildingsCompareCell;
  floating?: boolean;
  blockType?: TBlockType;
}

export type TBlockType = 'flats' | 'infrastructure';

export const Cell = ({ type, cell, floating, blockType }: ICellProps): React.JSX.Element | null => {
  switch (type) {
    case 'text':
      return <TextCell cell={cell as ITextCell} />;

    case 'link':
      return <LinkCell cell={cell as ILinkCell} isFlatsBlock={blockType === 'flats'} />;

    case 'textList':
      return <TextListCell cell={cell as ITextListCell} isInfrastructureBlock={blockType === 'infrastructure'} />;

    case 'promotions':
      return <PromotionCell cell={cell as IPromotionCell} />;

    case 'gallery':
      return <GalleryCell cell={cell as IGalleryCell} />;

    case 'valuation':
      return <PriceCell cell={cell as IPriceCell} />;

    case 'developer':
      return <DeveloperCell cell={cell as IDeveloperCell} />;

    case 'roomStats':
      return <RoomStatsCell cell={cell as IRoomStatsCell} />;

    case 'infrastructure':
      return <InfrastructureCell cell={cell as IInfrastructureCell} />;

    case 'transportPointExtended':
      return <TransportPointExtendedCell cell={cell as ITransportPointExtendedCell} />;

    // transportPoint и transportDistance приходят только с мобильной ручки.
    case 'transportPoint':
      return <TransportPointCell cell={cell as ITransportPointCell} />;

    case 'transportDistance':
      return <TransportDistanceCell cell={cell as ITransportDistanceCell} />;

    case 'newbuildingSummary':
      return floating ? (
        <NewbuildingSummaryCellFloating cell={cell as INewbuildingSummaryCell} />
      ) : (
        <NewbuildingSummaryCell cell={cell as INewbuildingSummaryCell} />
      );

    default:
      return null;
  }
};
